const apiBaseUrl = process.env.REACT_APP_API_URL || 'http://localhost:8080';

async function parseResponseData(response) {
  const contentType = response.headers.get('content-type') || '';

  if (contentType.includes('application/json')) {
    return response.json();
  }

  const text = await response.text();
  return text ? { message: text } : null;
}

export async function sendRequestInfo(request) {
  const response = await fetch(`${apiBaseUrl}/api/request-info`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(request),
  });

  const data = await parseResponseData(response);

  if (!response.ok) {
    throw new Error(data?.error || data?.message || 'Could not send the request. Please try again later.');
  }

  return data;
}
